import { Button, Result } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function NoMatch() {
  const history = useHistory();
  const { t, i18n } = useTranslation()

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('admin.noMatch.subTitle')}
      extra={
        <Button type="primary" onClick={() => history.push("/")}>
          {t('admin.noMatch.backHomeBtn')}
        </Button>
      }
    />
  );
}

export default NoMatch;
